<script setup lang="ts">
import type {TbiScheme} from '#server/types/PymentMethodInterface'
import {chooseTbiScheme} from '~/services/tbi'
const props = defineProps<{schemes: TbiScheme[]; amount: number}>()
const selected = defineModel<number | undefined>()
const {t, locale} = useI18n()
watch(() => props.schemes, value => { selected.value = chooseTbiScheme(value, selected.value) }, {immediate: true})
const scheme = computed(() => props.schemes.find(item => item.id === selected.value))
const money = (value: number) => new Intl.NumberFormat(locale.value, {style: 'currency', currency: 'EUR'}).format(value)
</script>
<template>
    <div class="tbi-schemes">
        <el-select v-if="schemes.length" v-model="selected" :aria-label="t('tbi_term')" class="w-100">
            <el-option v-for="item in schemes" :key="item.id" :value="item.id" :label="`${item.period} ${t('tbi_months')} · ${money(item.installment)}/${t('tbi_month')}`" />
        </el-select>
        <dl v-if="scheme" class="tbi-terms">
            <div><dt>{{ t('tbi_financed_amount') }}</dt><dd>{{ money(amount) }}</dd></div>
            <div><dt>{{ t('tbi_installment') }}</dt><dd><strong>{{ money(scheme.installment) }}</strong></dd></div>
            <div><dt>{{ t('tbi_term') }}</dt><dd>{{ scheme.period }} {{ t('tbi_months') }}</dd></div>
            <div><dt>{{ t('tbi_nir') }}</dt><dd>{{ scheme.nir }}%</dd></div>
            <div><dt>{{ t('tbi_apr') }}</dt><dd>{{ scheme.apr }}%</dd></div>
            <div><dt>{{ t('tbi_total_due') }}</dt><dd>{{ money(scheme.total_due) }}</dd></div>
        </dl>
        <p v-else class="text-muted">{{ t('tbi_no_schemes') }}</p>
        <p class="tbi-note">{{ t('tbi_quote_hint') }}</p>
    </div>
</template>
<style scoped>
.tbi-terms { display: grid; gap: 10px; margin: 20px 0; font-size: 14px; }
.tbi-terms > div { display: flex; justify-content: space-between; gap: 20px; }
.tbi-terms dt { font-weight: 400; color: var(--el-text-color-secondary); }
.tbi-terms dd { margin: 0; font-variant-numeric: tabular-nums; }
.tbi-note { color: var(--el-text-color-secondary); font-size: 12px; line-height: 1.6; margin-bottom: 0; }
</style>
